The response from the `createApplicationQuestionnaire` mutation.
